import { render, staticRenderFns } from "./PaySlip.vue?vue&type=template&id=0dd22c5e&scoped=true"
import script from "./PaySlip.vue?vue&type=script&lang=js"
export * from "./PaySlip.vue?vue&type=script&lang=js"
import style0 from "./PaySlip.vue?vue&type=style&index=0&id=0dd22c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd22c5e",
  null
  
)

export default component.exports